import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const clearState = createAction(ACTION.CLEAR_STATE);
export const resetError = createAction(ACTION.RESET_ERROR, (params) => ({params}));
